module.exports = __webpack_public_path__ + "img/monitor.a4f07056.png";